import React, { useState, useEffect } from 'react';
import { 
  Typography, Paper, Table, TableBody, TableCell, TableContainer, 
  TableHead, TableRow, Button, Box, IconButton
} from '@mui/material';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

const CustomersList = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      const response = await api.get('/api/customers');
      setCustomers(response.data);
      setError(null);
    } catch (err) {
      console.error('Error fetching customers:', err);
      setError('Virhe asiakkaiden haussa. Yritä myöhemmin uudelleen.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm('Haluatko varmasti poistaa tämän asiakkaan?')) {
      try {
        await api.delete(`/api/customers/${id}`);
        // Refresh the list after deletion
        fetchCustomers();
      } catch (err) {
        console.error('Error deleting customer:', err);
        setError('Virhe asiakkaan poistossa. Yritä myöhemmin uudelleen.');
      }
    }
  };

  return (
    <div>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" component="h1">
          Asiakkaat
        </Typography>
        <Button 
          variant="contained" 
          color="primary" 
          component={Link} 
          to="/customers/new"
          startIcon={<AddIcon />}
        >
          Uusi asiakas
        </Button>
      </Box>

      {error && (
        <Paper sx={{ p: 2, mb: 2, bgcolor: '#ffebee' }}>
          <Typography color="error">{error}</Typography>
        </Paper>
      )}

      {loading ? (
        <Typography>Ladataan asiakkaita...</Typography>
      ) : customers.length === 0 ? (
        <Paper sx={{ p: 3 }}>
          <Typography>Ei asiakkaita. Luo uusi asiakas aloittaaksesi.</Typography>
        </Paper>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Nimi</TableCell>
                <TableCell>Sähköposti</TableCell>
                <TableCell>Puhelin</TableCell>
                <TableCell>Osoite</TableCell>
                <TableCell>Toiminnot</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customers.map((customer) => (
                <TableRow key={customer.id}>
                  <TableCell>{customer.name}</TableCell>
                  <TableCell>{customer.email || '-'}</TableCell>
                  <TableCell>{customer.phone || '-'}</TableCell>
                  <TableCell>{customer.address || '-'}</TableCell>
                  <TableCell>
                    <IconButton 
                      component={Link} 
                      to={`/customers/edit/${customer.id}`}
                      color="primary"
                      size="small"
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton 
                      onClick={() => handleDelete(customer.id)}
                      color="error"
                      size="small"
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </div>
  );
};

export default CustomersList;
